import { dateFormat } from 'highcharts';
import {MasterStatusList, ProductListManualVm, ProjectFilesVm, ProjectStatus, ReviewLog } from './project-vm'
export class GinfoSpProjectDetailsVm {
    projectTitle: string;
    pwrNumber: string;
    eventId: string;
    logo: string;
    callouts: string;
    mabd? : Date | null;
    madbStr : string;
    retailOffer: string;
    sreSpoc: number;
    location: string;
    displayType : number;
    productFlow: string;
    sellingPoints: string;
    productFLowList?: SalesplanProductFlow[];
    locationId : number;

    orgId?: number;
    type?: string;
    vendorId?: number;
    salesplanId?: number;
    ctRequester?: number;

    constructor() {
        this.projectTitle = '';
        this.pwrNumber = '';
        this.eventId = '';
        this.logo = '';
        this.callouts = '';
        this.mabd = null;
        this.madbStr = '';
        this.retailOffer = '';
        this.sreSpoc = 0;
        this.location = '';
        this.displayType = 0;
        this.productFlow='';
        this.sellingPoints = '';
        this.productFLowList = [];
        this.locationId = 0;
    }
}

export class GinfoSpKeyDatesVm {    
    startDateStr?: string | null;
    endDateStr?: string | null;
    submittedDateStr?: string | null;
    pwrDateStr?: string | null;
    approvedOnStr?: string | null;
    initiatedDateStr?: string | null;

    startDate?: Date| null;
    endDate?: Date| null;
    submittedDate?: Date | null;
    approvedOn?: Date | null;
    pwrDate?: Date | null;
    initiatedDate?: Date | null;

    constructor() {
        this.startDate = null;
        this.endDate = null;
        this.submittedDate = null;
        this.approvedOn = null;
        this.pwrDate = null;
        this.initiatedDate = null;
    }
}


export class SalesplanGeneralInfoVm {
    salesplanDetails: GinfoSpProjectDetailsVm;
    storeList: ProjectFilesVm| null;
    storeListManual?: ProjectFilesVm | null;
    isStoreManual?: boolean | null;
    keyDates: GinfoSpKeyDatesVm;

    constructor() {
        this.salesplanDetails = new GinfoSpProjectDetailsVm();
        this.storeList = null;
        this.storeListManual = null;
        this.keyDates = new GinfoSpKeyDatesVm();
        this.isStoreManual = false;
    }
}

export class SalesplanStatus {
    projectStatusID?: number;
    refID? : number;
    statusID?: number;
    type?: string;
    changedBy?: number;
    changedDate?: Date;

    constructor(projectStatusID?: number, refID?: number, statusID?: number, type?: string,changedBy?: number,changedDate?:Date) {
        this.projectStatusID = projectStatusID;
        this.refID = refID;
        this.statusID = statusID;
        this.type = type;
        this.changedBy = changedBy;
        this.changedDate = changedDate;
    }
}
export class ProjectApproval {
    approvalID?: number;
    refID? : number | undefined | null;
    requestedBy?: number;
    requestedDate?: Date;
    approvedBy?: number;
    approvedDate?: Date;
    type?: string;
    isReviewClicked?: boolean | false;
    isApproveClicked?: boolean | false;
    isDisbleApprovalsBtns?: boolean | false;
    isDisbleReviewRequestBtn?: boolean | false;
    isDisbleReviewComments?: boolean | false;
    approvalStatus?: string;
    actionBy?:string; 
    approvalStage?:string;  
    actionDate?:Date;
    isReviewRequestCompleted?:boolean | false;

    
 
    constructor(approvalID?: number, refID?: number, requestedBy?: number,
        requestedDate?: Date,approvedBy?: number,approvedDate?:Date, type?: string,
        isReviewClicked?: boolean, isApproveClicked?: boolean,
        isDisbleApprovalsBtns?: boolean,isDisbleReviewRequestBtn?: boolean,
        isDisbleReviewComments?: boolean,actionBy?:string,
        approvalStatus?: string,approvalStage?:string,actionDate?:Date,isReviewRequestCompleted?:boolean
    ) {
        this.approvalID = approvalID;
        this.refID = refID;
        this.requestedBy = requestedBy;
        this.requestedDate = requestedDate;
        this.approvedBy = approvedBy;
        this.approvedDate = approvedDate;
        this.type = type;
        this.isReviewClicked = false;
        this.isApproveClicked = false;
        this.isDisbleApprovalsBtns=false;
        this.isDisbleReviewRequestBtn=false;
        this.isDisbleReviewComments=  false;
        this.approvalStatus=approvalStatus;
        this.actionBy=actionBy;
        this.approvalStage=approvalStage;
        this.actionDate=actionDate;
        this.isReviewRequestCompleted=isReviewRequestCompleted;
    }
}

export class SalesPlanImagesVm {
    imageFiles: SalesPlanImageFilesVm[] = [];
    logoFiles: SalesPlanImageFilesVm[] = [];
    callouts?: string;
    sellingPoints?: string;
    
    constructor() {
        this.imageFiles = new Array<SalesPlanImageFilesVm>();
        this.logoFiles = new Array<SalesPlanImageFilesVm>();
        this.callouts = '';
        this.sellingPoints = '';
    }
}

export class SalesPlanImageFilesVm {
    imageID?: number;
    salesPlanID?: number;
    imageName?: string;
    fileIndexID?: number;
    filePath?: string;
    base64Bytes?: string;
    fileSent?: boolean;
    fileIndex?: number;
    type?: string;
    tempUniqueId?: string;

    constructor() {
        this.imageID = 0;
        this.salesPlanID = 0;
        this.imageName = '';
        this.fileIndexID = 0;
        this.filePath = '';
        this.base64Bytes = "";
        this.fileSent = false;
        this.fileIndex = 0;
        this.type = "";
        this.tempUniqueId = "";
    }
}


export class SalesPlanVm {
    headerId : number;
    orgID : number;
    vendorId?: number;
    salesplanId : number;
    category : number;
    requestor : number;
    requestorName : string;
    generalInfo: SalesplanGeneralInfoVm;
    images : SalesPlanImagesVm;
    products: ProjectFilesVm| null;
    productsManual: ProductListManualVm[] | null;
    salesPlanStatus : SalesplanStatus;
    projectStatus: ProjectStatus | null;
    projectApproval : ProjectApproval | null;    
    isProductManual?: boolean;
    isProductReviewConfirmed?: boolean;    
    projectStatuses: ProjectStatus[] | null;
    projectStatusMaster?: MasterStatusList[] | null;
    selectedCategories: number[]=[];
    productsReviewLog: ReviewLog[] | null;
    refProjectId?: number;
    selectedStoresByStates: string | null; 
    identifiedStores: string | null;
    storesToIdentify: string | null;

    constructor() {
        this.headerId = 0;
        this.orgID = 0;
        this.vendorId = 0;
        this.salesplanId = 0;
        this.category = 0;
        this.requestor = 0;
        this.requestorName = "";
        this.generalInfo = new SalesplanGeneralInfoVm();
        this.images = new SalesPlanImagesVm();
        this.products = null;
        this.productsManual = null;
        this.salesPlanStatus = new SalesplanStatus();
        this.projectApproval = null;        
        this.isProductManual = false;
        this.isProductReviewConfirmed = false;
        this.projectStatus = null;
        this.projectStatuses = [];
        this.projectStatusMaster =null;
        this.productsReviewLog = null;
        this.selectedStoresByStates = null;
        this.identifiedStores = null;
        this.storesToIdentify = null;
    }
}

export class ReviewLogDto {
    refID?: number | null;
    type?: string | null;
    comment?: string | null;
    actionBy?: string | null;
    actionDate?: Date | null;
}

export class ProductFlow
{
    productFlowID?: number;
    productFlowDescription?: string;
    isActive?: boolean;
    createdBy?: number; 
    updatedBy?: number;
    createdDate?: Date;
    updatedDate?: Date;
}

export class SalesplanProductFlow
{
    salesplanProductFlowID?: number;
    productFlowID?: number;
    salesPlanID?: number;
}

export class LocationDto {
    locationID?: number | null;
    locationName?: string | null;
    isActive?: boolean | false;
    createdBy?: string | null;
    createdDate?: Date | null;   
}